module.exports = __webpack_public_path__ + "img/paboo.c5df27b2.png";